import type { JSX } from 'solid-js';
import type { CardTone } from '../../lib/machine-card';
import { Button } from '../ui/Button';

// The card's state action (#6785, prototype actionBtn): Open, Resume now, Fix access,
// Decide or Reconnect. Every one opens the machine details panel (#6563 v2); a read-only
// card's reads "Open". The wrapper carries the tone, so the button keeps the shared look and
// a warning or critical state colours only its words.

export function CardAction(props: {
  readonly label: string;
  readonly tone: CardTone;
  readonly size: 'banner' | 'footer' | 'line';
  readonly onPress: () => void;
}): JSX.Element {
  return (
    <span class="mission-card__act" data-tone={props.tone} data-size={props.size}>
      <Button
        variant={props.size === 'line' ? 'ghost' : 'outline'}
        size="sm"
        onClick={props.onPress}
      >
        {props.label}
      </Button>
    </span>
  );
}
